import { CognitiveDisorderDetailStatus } from './constants'
import { jobSupportProjectParticipant } from '../job-support-project'
import { WeekDay } from '../shared'
import {
  AgeRange,
  ApplyingDueDate,
  ApplyingMethod,
  ApplyingOption,
  CognitiveDisorderStatus,
  CohabitingFamily,
  EnvironmentOption,
  ExcretionAssistance,
  Gender,
  Grade,
  HouseworkAssistance,
  JobPostingStatus,
  MealAssistance,
  MovementAssistance,
  PayType,
  SurveyStatus,
  WorkType,
  WorkingHoursType,
} from './types'
export interface WorkTime {
  // type: string;
  start_at: string
  end_at: string
  // break_time: string;
}

export interface JobPostingCustomer {
  id: string
  // 어르신 정보
  age?: number
  gender?: Gender
  grade?: Grade
  weight?: number
  diseaseNote?: string
  cognitiveDisorder?: CognitiveDisorderStatus
  cognitiveDisorderDetail?: CognitiveDisorderDetailStatus[]
  cohabitingFamily?: CohabitingFamily
  environmentOptions?: EnvironmentOption[]
  environmentNote?: string
  // 어르신 특별 서비스
  mealAssistances?: MealAssistance[]
  excretionAssistances?: ExcretionAssistance[]
  movementAssistances?: MovementAssistance[]
  houseworkAssistances?: HouseworkAssistance[]
  additionalNote?: string

  customerInfo?: { name: string; value: string }[]
  serviceInfo?: { name: string; value: string }[]
}

export interface JobPosting {
  id?: number
  public_id: string
  business_id: string
  title: string
  work_type: WorkType
  working_hours_type: WorkingHoursType
  days_text: string
  working_days: string[]
  work_start_time: string
  work_end_time: string
  pay_type: PayType
  min_wage: number
  max_wage: number
  welfare_types?: string[]
  address: string
  applying_info: any[]
  applying_options: string[]
  business_info: any[]
  status: JobPostingStatus
  proposal_usable_count: number
  proposed_user_ids: string[]

  call_feedbacks: { user_public_id: string; feedback: string }[]
  init_contacting_tickets: number
  used_contacting_tickets: number
  business_phone_number: string
  can_negotiate_salary: boolean
  can_negotiate_work_time: boolean
  center_name: string
  description: string
  distance: string
  hours_text: string
  is_closed: boolean
  is_saved: boolean
  is_special: boolean
  job_posting_customer: {
    id: string
    customer_info: any[]
    service_info: any[]
    age?: number
    gender?: Gender
    grade?: Grade
    weight?: number
    disease_note?: string
    cognitive_disorder?: CognitiveDisorderStatus
    cohabiting_family?: CohabitingFamily
    environment_options?: EnvironmentOption[]
    meal_assistances?: MealAssistance[]
    excretion_assistances?: ExcretionAssistance[]
    movement_assistances?: MovementAssistance[]
    housework_assistances?: HouseworkAssistance[]
    additional_note?: string
  }
  lat: string
  lng: string
  location: string
  manager_phone_number: string
  pay_text: string
  published_at: string
  welfare: string
  applying_methods: string[]
  applying_due_date: ApplyingDueDate
  manager_email: string
  business_satisfaction_survey?: Survey
  premium_matching?: string
  paid_features?: { feature: string; created_at: string }[]
  have_job_posting_result?: boolean
}

export interface JobPostingSort {
  column: string
  order: string
}

export interface JobPostingsSummary {
  total_job_postings_count: number
  closed_job_postings_count: number
  init_job_postings_count: number
  draft_job_postings_count: number
}

export interface JobPostingsByBusiness {
  jobPostings: BbasJobPostingForBusiness[]
  totalCount: number
}

export type CallFeedbackType =
  | 'not_active'
  | 'not_matched'
  | 'interview_scheduled'
  | 'not_answering'

export interface CreateCallFeedbackData {
  user_public_id: string
  feedback: CallFeedbackType
}

export interface Survey {
  id: number
  job_posting_public_id: string
  status: SurveyStatus
  interview_date: Date
  gender: Gender
  age: AgeRange
  score: number
  score_reason: string
  improving_suggestion: string
}

export interface BbasStatiscData {
  id: bigint
  createdAt: Date
}
export interface BbasMessageHistories {
  createdAt: string
  scheduledAt: string
  isCancel: boolean
  status: string
  typeName: string
}

export interface JobPostingMatchingRateProperty {
  publicId: string
  title: string
  centerName: string
  jobPostingId: string
  welfareTypes?: string[]
  workingDays: string[]
  gender: Gender
  grade: Grade
  workType: WorkType
  payType: PayType
  maxWage: number
  applyingOptions: string[]
  canNegotiateWorkTime: boolean
  workStartTime: string
  workEndTime: string
  jobPostingCustomer?: JobPostingCustomer
  welfare: string
  isSpecial: boolean
}

export interface BbasJobPostingForBusiness extends JobPostingMatchingRateProperty {
  id?: number
  publicId: string
  businessId: string
  workingHoursType: WorkingHoursType
  daysText: string
  minWage: number
  address: string
  applyingInfo: any[]
  businessInfo: any[]
  status: JobPostingStatus
  proposalUsableCount: number
  proposedUserIds: string[]
  callFeedbacks: { userPublicId: string; feedback: string }[]
  initContactingTickets: number
  usedContactingTickets: number
  businessPhoneNumber: string
  canNegotiateSalary: boolean
  description: string
  distance: string
  hoursText: string
  closingAt?: string
  createdAt?: string
  isClosed: boolean
  isSaved: boolean
  isSpecial: boolean
  lat: string
  lng: string
  location: string
  managerPhoneNumber: string
  payText: string
  publishedAt: string
  welfare: string
  applyingMethods: string[]
  applyingDueDate: ApplyingDueDate
  managerEmail: string
  businessSatisfactionSurvey?: Survey
  premiumMatching?: boolean
  paidFeatures?: { feature: string; createdAt: string; paidStatus?: string }[]
  haveJobPostingResult?: boolean
  acceptedProposals: BbasStatiscData[]
  rejectedProposals: BbasStatiscData[]
  waitingProposals: BbasStatiscData[]
  notifications: {
    groupByMessageCount: {
      [key: string]: number
    }
    result: { totalCount: number; confirmedCount: number }
  }
  messageHistories: BbasMessageHistories[]
  proposals: {
    accepted?: any[]
    waiting?: any[]
    rejected?: any[]
  }
  jobPostingResults: any
  contactMessages: any[]
  userSavedJobPostings: any[]
  jobApplications: any[]
  careerCertifications: any[]
  jobPostingsConnects: any[]
  targetNotificationsCount?: number
  isClosedNeedParticipant?: boolean
  lastCheckedProposalsAt?: Date
  lastCheckedJobApplicationsAt?: Date
  lastCheckedContactMessagesAt?: Date
  lastCheckedUserSavedJobPostingsAt?: Date
  lastCheckedCareerCertificationsAt?: Date
  lastCheckedJobPostingsConnectsAt?: Date
  notificationConfirmedUsersCount?: number
  guardianPhoneNumber?: string
  isUntilTomorrow?: boolean
  preferredGender?: string
  businesses?: {
    name?: string
  }
  possibleWorkCollections?: string[]
  jobSupportProjectParticipants?: jobSupportProjectParticipant[]
}

export enum PreferredGender {
  All = 'all',
  Male = 'male',
  Female = 'female',
}

export interface IJobPostingForCaregiver extends JobPostingMatchingRateProperty {
  id?: string
  publicId: string
  workingHoursType: WorkingHoursType
  address: string
  latitude?: number
  longitude?: number
  workingDays: WeekDay[]
  workStartTime: string
  daysText?: string
  hoursText?: string
  payText?: string
  workEndTime: string
  canNegotiateSalary: boolean
  minWage: number
  description?: string
  status: JobPostingStatus
  lat?: string
  lng?: string
  distance: string
  welfare: string
  isSpecial: boolean
  virtualNumber: string
  publishedAt: Date
  isClosed?: boolean
  location?: string
  employmentType?: string

  // Survey Information
  userSatisfactionSurvey?: Survey

  // Application qualifications and methods
  applyingOptions: ApplyingOption[]
  applyingMethods: ApplyingMethod[]
  applyingDueDate: ApplyingDueDate
  managerEmail: string
  createdAt?: Date
  updatedAt?: Date
  closingAt?: Date
  matchingRate?: number

  // Worknet
  worknetJobPostingYes?: boolean
  originalPostingUrl?: string
  originalPostingId?: string
  worknetContact?: string
  scrapedWorknetJobPostingId?: string
  isBusinessFreeTrialJobPosting?: boolean

  applyingInfo?: { name: string; value: string }[]
  businessInfo?: { name: string; value: string }[]
  businessInfoSummary?: {
    hasRegistration: boolean
    count: JobPostingCountInfo
    address: string
  }
  isSaved?: boolean
  viewCount?: number
  preferredGender?: PreferredGender
  agreedToJobSupportProjectAt?: string
  isHospitalCompanionJobPosting?: boolean
}

export interface JobPostingCountInfo {
  jobPosting: number
  recruitSuccess: number
  jobSupportProjectSuccess: number
}

export type DifficultyStatus = {
  isDifficultGrade: boolean
  isDifficultCohabitingFamily: boolean
  isDifficultMovementAssistance: boolean
  isDifficultHouseWork: boolean
  isDifficultExcretionAssistance: boolean
  isDifficultMealAssistance: boolean
}

export interface JobPostingFormData {
  workType: WorkType
  workingHoursType: WorkingHoursType
  address: string
  workingDays: string[]
  workStartTime: string
  workEndTime: string
  isUntilTomorrow: boolean
  payType: PayType
  minWage: number
  maxWage: number
  welfareTypes?: string[]
  canNegotiateWorkTime: boolean
  canNegotiateSalary: boolean
  description?: string
  isRequestPaid?: boolean

  status: JobPostingStatus

  jobPostingCustomer?: {
    age?: number | string
    gender?: Gender
    grade?: Grade
    weight?: number
    diseaseNote?: string
    cognitiveDisorder?: CognitiveDisorderStatus
    cohabitingFamily?: CohabitingFamily
    environmentOptions?: EnvironmentOption[]
    mealAssistances?: MealAssistance[]
    excretionAssistances?: ExcretionAssistance[]
    movementAssistances?: MovementAssistance[]
    houseworkAssistances?: HouseworkAssistance[]
    additionalNote?: string
  }

  title: string
  applyingOptions?: string[]
  applyingMethods: string[]
  applyingDueDate?: ApplyingDueDate
  managerEmail: string
  managerPhoneNumber: string
  closingAt?: Date
  publishedAt?: Date

  preferredGender?: string
}
